<template>
  <div>
    <loading-screen v-if="isLoading" />
    <tabbed :title="$t('text.changeRecurrenceNotifications.title')">
      <p class="text-sm">
        {{ $t('text.changeRecurrenceNotifications.msg') }}
      </p>
      <p class="text-sm">
        {{ $t('text.changeRecurrenceNotifications.inputLabel') }}
      </p>

      <input-phone
        v-model="notificationNumber"
        type="tel"
        :placeholder="notificationNumber || '00000000'"
        :max-length="8"
        pattern="[0-9A-Z]{8}*"
        :formatter="formatInput"
        :lada="country.lada"
        :only-numbers="true"
        name="notificationNumber"
        color="mediumgray"
        input-class="h-12 text-xl"
        @input="onInput"
      />
      <p
        v-if="error"
        class="text-danger text-center"
      >
        {{ error }}
      </p>
    </tabbed>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { InputPhone } from '@/components/ui';
import Tabbed from '@/components/Tabbed';
import { INVOICE_CONTROLLERS } from '../../../utils/constants';

export default {
  name: 'ChangeRecurrenceNotificationMsisdn',
  components: { InputPhone, Tabbed },
  props: {
    paymentInfo: {
      type: Object,
      required: true
    },
    app: {
      type: String,
      default: INVOICE_CONTROLLERS.MPC
    }
  },
  data() {
    return {
      isLoading: false,
      notificationNumber: (this.paymentInfo.successInfo
        && this.paymentInfo.successInfo.notificationNumber)
        || '',
      error: ''
    };
  },
  computed: {
    ...mapGetters(['country'])
  },
  methods: {
    formatInput(value) {
      this.error = '';
      return String(value).substring(0, 8);
    },
    onInput(value) {
      this.$emit('input', value);
    }
  }
};
</script>

